import { Button, Flex, HStack, Radio, Stack, Text, useToast } from '@chakra-ui/react'
import type { AxiosError } from 'axios'
import { InputFormControl, RadioGroupFormControl, SwitchFormControl, TextareaFormControl } from 'BrokerTsLib/src/components'
import CustomTooltip from 'BrokerTsLib/src/components/CustomTooltip'
import type { BadRequestError, FlexGroup, UpdateFlexGroup } from 'BrokerTsLib/src/dtos'
import { useGetFlexGroupTypes } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'
import { setModelStateErrors } from 'BrokerTsLib/src/Utils/formModelState'

import { Info } from '@/icons'

import { FormSection } from '../forms/FormSection'

export const FlexGroupForm = ({ flexGroup, isCreate, onSubmit }: { flexGroup: UpdateFlexGroup, isCreate?: boolean, onSubmit: (data: UpdateFlexGroup) => Promise<FlexGroup | AxiosError> }) => {
  const toast = useToast()
  const { data: types } = useGetFlexGroupTypes()

  const methods = useForm<UpdateFlexGroup>({
    defaultValues: { ...flexGroup },
  })
  const {
    handleSubmit,
    formState: { isSubmitting },
    setError,
    control
  } = methods

  const submit = (data: UpdateFlexGroup) => {
    onSubmit(data)
      .catch((e: AxiosError) => {
        if (e.response?.status === 400)
          setModelStateErrors(setError, e.response.data as BadRequestError<UpdateFlexGroup>)
        else
          toast({
            title: 'Chyba',
            description: `Při ${isCreate ? 'vytváření' : 'úpravě'} flexibilní skupiny došlo k chybě`,
            status: 'error',
          })
      })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submit)}>
        <FormSection sectionTitle="" wide>
          <Stack gap={6}>
            <InputFormControl name="name" control={control} label="Název" rules={{ required: 'Zadejte název' }} />

            <TextareaFormControl name="description" control={control} label="Popis" />

            <RadioGroupFormControl name="type" label="Typ" rules={{ required: 'Vyberte typ' }} valueAsNumber>
              <Stack gap={3}>
                {types?.map(t => <Radio key={t.type} value={t.type.toString()}>
                  <CustomTooltip label={t.description}>
                    <HStack>
                      <Text>{t.name}</Text>
                      <Info boxSize={4} />
                    </HStack>
                  </CustomTooltip>
                </Radio>)}
              </Stack>
            </RadioGroupFormControl>

            {!isCreate && <SwitchFormControl name="valid" control={control} label="Aktivní" />}

            <Flex justifyContent={'space-between'}>
              <Button colorScheme="primary" isLoading={isSubmitting} type="submit" marginLeft={'auto'}>
                {isCreate ? 'Vytvořit' : 'Uložit'}
              </Button>
            </Flex>
          </Stack>
        </FormSection>
      </form>
    </FormProvider>
  )
}